
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M97 50c0 25.957-21.043 47-47 47S3 75.957 3 50 24.043 3 50 3s47 21.043 47 47z","stroke-width":"6","fill":"none"}}),_c('path',{attrs:{"d":"M32.289 61.709a8.905 8.905 0 008.905-8.905c0-4.919-3.987-5.608-8.905-5.608-4.918 0-8.905.69-8.905 5.608a8.905 8.905 0 008.905 8.905zm35.324 0a8.905 8.905 0 008.905-8.905c0-4.919-3.987-5.608-8.905-5.608-4.918 0-8.905.69-8.905 5.608a8.905 8.905 0 008.905 8.905zM39.709 77.244c0-2.375 1.187-4.75 3.166-6.333A10.45 10.45 0 0150 68.437c2.572 0 5.145.89 7.124 2.573 1.979 1.583 3.265 3.958 3.166 6.332-2.078-1.187-3.859-1.88-5.541-2.275-1.682-.495-3.265-.594-4.848-.594-1.584 0-3.167.198-4.75.594-1.583.297-3.364 1.088-5.442 2.177z","data-fill-colored":"true"}})])
          )
        }
      }
    